module.exports = __webpack_public_path__ + "media/virtualStaging/galleryImage7-b17f8e6b.jpeg";